var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomDropdown',{class:{'select-form': true},attrs:{"name":"time-selector","value":_vm.value,"options":_vm.timeOptions,"placeholder":_vm.placeholder,"color":_vm.color},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }